<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Perfil de Usuario</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex order-xs2 order-md2 xs12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="userForm.firstName"
                      label="Nombre(s)"
                      :error-messages="nameErrors"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="userForm.lastName"
                      label="Apellidos"
                      :error-messages="lastNameErrors"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="userForm.mail"
                      label="Email"
                      :error-messages="emailErrors"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field label="Rol" required disabled :value="userForm.webRole.name"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      :disabled="working.wUpdate"
                      @click="modals.cPassword = true"
                      round
                      dark
                      small
                      color="gradiente"
                    >Cambiar Contraseña</v-btn>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      :disabled="working.wUpdate"
                      @click="modals.QRcoll = true"
                      round
                      dark
                      small
                      color="gradiente"
                    >Obtener QR de Escuela</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex order-xs1 order-md2 xs8 offset-xs2 md6 offset-md0>
                <v-layout
                  align-center
                  justify-center
                  row
                  wrap
                  fill-height
                  v-on:mouseover="flags.updateImage = true"
                  v-on:mouseleave="flags.updateImage = false"
                >
                  <v-flex style="text-align: center;" sm7 v-show="working.wImage">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-flex>
                  <v-flex
                    style="border-radius: 50%; text-align:center;"
                    id="parentContainerImage"
                    xs7
                    :class="!getUser || !getUser.imageStorage || !getUser.imageStorage.miniObjUrl ? 'gradiente' : ''"
                    v-show="!working.wImage"
                  >
                    <label id="img_edit_profile_default" for="edit_profile">
                      <v-img
                        v-if="!getUser || !getUser.imageStorage || !getUser.imageStorage.miniObjUrl"
                        :src="require('@/assets/panel/modals/AddPhotoIcon@3x.png')"
                      ></v-img>
                      <v-img
                        style="border-radius: 50%; text-align:center;"
                        v-else
                        :src="getUser.imageStorage.miniObjUrl"
                      ></v-img>
                    </label>
                    <label style="display: none" id="img_edit_profile" for="edit_profile"></label>
                  </v-flex>
                  <br />
                  <v-flex xs7>
                    <v-expand-transition>
                      <v-btn
                        block
                        class="gradiente"
                        style="border-radius: 33px;"
                        v-show="flags.updateImage"
                        dark
                        @click="modals.image = true"
                      >Actualizar</v-btn>
                    </v-expand-transition>
                    <editImage
                      :title="(userImg != null) ? 'Editar imagen' : 'Añadir imagen'"
                      v-on:loaded="processImage($event)"
                      v-model="modals.image"
                    ></editImage>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">Cancelar</v-btn>
          <v-btn :disabled="working.wUpdate" color="primary darken-1" flat @click="update()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ChangePassword v-model="modals.cPassword" v-on:Update="update"></ChangePassword>
    <loading v-model="working.wUpdate" text="Actualizando..."></loading>
    <success v-model="toast.success" text="Actualización Exitosa"></success>
    <error v-model="toast.failed" :text="toast.eMessage"></error>
    <editImage v-on:loaded="processImage($event)" v-model="modals.image" :title="modals.editImageTitle"></editImage>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import { funciones } from "../../Mixins/Funciones.js";
import loading from "../Dialogs/Loading.vue";
import success from "../Dialogs/Success.vue";
import error from "../Dialogs/Error.vue";
import ChangePassword from "./ChangrePassword";
import editImage from "./EditImage";
import qrView from "./viewQRBranch";
export default {
  components: {
    loading,
    success,
    error,
    ChangePassword,
    editImage,
    qrView,
  },
  mixins: [funciones],
  props: ["value","formBranch"],
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      mail: { required, email }
    }
  },
  data: () => ({
    userForm: {
      webRole: {}
    },
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false
    },
    toast: {
      success: false,
      failed: false,
      eMessage: "Ups ocurrió un error"
    },
    modals: {
      QRcoll: false,
      cPassword: false,
      image: false
    },
    flags: {
      updateImage: false
    }
  }),
  watch: {
    value() {
      if (this.value) {
        this.userForm = this.getUser;
      } else {
        this.userform = {};
      }
    }
  },
  methods: {
    close() {
				this.$emit("input", !this.value);
			},
    update() {
      
    },
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.userForm.firstName.$dirty) return errors;
      !this.$v.userForm.firstName.required && errors.push("Nombre obligatorio");
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.userForm.lastName.$dirty) return errors;
      !this.$v.userForm.lastName.required &&
        errors.push("Apellidos obligatorios");

      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.userForm.mail.$dirty) return errors;
      !this.$v.userForm.mail.required && errors.push("Correo obligatorio");
      !this.$v.userForm.mail.email && errors.push("Correo inválido");
      return errors;
    },
    //Mappers
    ...mapGetters(["getUser"])
  }
};
</script>